export default {
  callingAPI: false,
  searching: '',
  //serverURI: 'http://192.168.0.22:8090',
  serverURI: 'http://127.0.0.1:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{1: 'test', 2: 'test'}],
    notifications: [],
    tasks: []
  },

  //Ed.

  papeletas : [],
  papeleta_seleccionada  : {},

  tipos_papeleta : [],
  marcacion : null,

  user : null,
  setUserCAS : null,

}



// WEBPACK FOOTER //
// ./src/store/state.js